/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Configuration } from '../../../Configuration';
import { RestServiceProvider } from '../../RestServiceProvider';
import { AccessProfileService } from './AccessProfileService';

class AccessProfileServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new AccessProfileService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { AccessProfileServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/AccessProfileServiceProvider.js